var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfAsqQuestionBody", {
    staticClass: "ds-question-table",
    class: _vm.getCss,
    attrs: { "show-index": _vm.showIndex, question: _vm._self },
    scopedSlots: _vm._u([
      {
        key: "answer",
        fn: function () {
          return [
            _c(
              "el-table",
              {
                ref: "table",
                attrs: {
                  data: _vm.rowsData,
                  border: "",
                  "header-cell-style": {
                    background: "#f5f7fa",
                    color: "#606266",
                  },
                },
              },
              [
                _c("el-table-column", {
                  attrs: { align: "center", label: "", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.text) + " ")]
                      },
                    },
                  ]),
                }),
                _vm._l(_vm.columns, function (it, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      "min-width": "100",
                      align: "center",
                      label: it.text,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-rate", {
                                staticStyle: { height: "auto" },
                                attrs: {
                                  value: Number(scope.row.model[it.uuid].value),
                                  max: _vm.max,
                                  disabled: _vm.readOnly || _vm.disabled,
                                  colors: _vm.colors,
                                  "void-icon-class": _vm.voidClass,
                                  "disabled-void-icon-class": _vm.voidClass,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeScore($event, scope, it)
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }